import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { SearchItemToCardModelPipe } from 'src/app/libs/_deprecated/search/search-item-to-card-model.pipe'
import { AnalyticsModule } from 'src/app/shared/analytics/analytics.module'
import { IfLoadedModule } from 'src/app/shared/directives/if-loaded/if-loaded.module'
import { SharedModule } from 'src/app/shared/shared.module'
import { ThumbnailModule } from 'src/app/shared/thumbnails/thumbnail.module'
import { StaticContentCardModule } from '../../content-card/static-content-card/static-content-card.module'
import { NoResultsModule } from '../../no-results/no-results.module'
import { PaginationModule } from '../../pagination/pagination.module'
import { OldSearchComponent } from './old-search.component'
import { OldSearchAnalyticsService } from './old-search-analytics.service'
import { OldTabsModule } from '../tabs/old-tabs.module'

@NgModule({
  imports: [
    SharedModule,
    NoResultsModule,
    OldTabsModule,
    CommonModule,
    RouterModule,
    ThumbnailModule,
    AnalyticsModule,
    FormsModule,
    ReactiveFormsModule,
    StaticContentCardModule,
    PaginationModule,
    IfLoadedModule
  ],
  exports: [OldSearchComponent],
  declarations: [OldSearchComponent, SearchItemToCardModelPipe],
  providers: [OldSearchAnalyticsService]
})
export class OldSearchModule {}
